import { render, staticRenderFns } from "./QuizWrongResponses.vue?vue&type=template&id=c498fdda&scoped=true&"
import script from "./QuizWrongResponses.vue?vue&type=script&lang=js&"
export * from "./QuizWrongResponses.vue?vue&type=script&lang=js&"
import style0 from "./QuizWrongResponses.vue?vue&type=style&index=0&id=c498fdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c498fdda",
  null
  
)

export default component.exports